
import React from "react";
import { Switch } from "@/components/ui/switch";
import { Role, Resource, PermissionType } from "@/hooks/rollenbeheer/types";

interface PermissionSwitchProps {
  role: Role;
  resource: Resource;
  permissionType: PermissionType;
  checked: boolean;
  onToggle: (role: Role, resource: Resource, permissionType: PermissionType, currentValue: boolean) => void;
}

const PermissionSwitch: React.FC<PermissionSwitchProps> = ({
  role,
  resource,
  permissionType,
  checked,
  onToggle
}) => {
  return (
    <div className="flex justify-center items-center">
      <Switch 
        checked={checked}
        onCheckedChange={() => 
          onToggle(role, resource, permissionType, checked)
        }
      />
    </div>
  );
};

export default PermissionSwitch;
